import React, { useState } from "react"
import { Button, Drawer, Tabs } from "antd"
import { ProfileOutlined } from "@ant-design/icons"
import useapi from "@/hooks/useapi"
import { fetchDagsExtract } from "@/api/dags.api"
import ExtractDags from "@pages/dags/metadata/extract"
import TransformDags from "@pages/dags/metadata/transform"
import LoadDags from "@pages/dags/metadata/load"
import PublishDags from "@pages/dags/metadata/publish"

const { TabPane } = Tabs

const MetadataDags = ({ dagId }: { dagId: string }) => {
  const [visible, setVisible] = useState(false)

  const onClose = () => {
    setVisible(false)
  }

  function callback(key: string) {
    console.log(key)
  }

  const renderContent = () => (
    <Tabs defaultActiveKey="1" onChange={callback}>
      <TabPane tab="Extract" key="1">
        <ExtractDags dagId={dagId} />
      </TabPane>
      <TabPane tab="Transform" key="2">
        <TransformDags dagId={dagId} />
      </TabPane>
      <TabPane tab="Load" key="3">
        <LoadDags dagId={dagId} />
      </TabPane>
      <TabPane tab="Publish" key="4">
        <PublishDags dagId={dagId} />
      </TabPane>
    </Tabs>
  )

  return (
    <div>
      <Drawer
        title={`Dags Meta -  ${dagId}`}
        placement="right"
        onClose={onClose}
        visible={visible}
        width={"900px"}
        destroyOnClose
      >
        {renderContent()}
      </Drawer>
      <Button type={"ghost"} size={"small"} onClick={() => setVisible(true)}>
        <ProfileOutlined />
      </Button>
    </div>
  )
}

export default MetadataDags
